import type { SelectHTMLAttributes } from "react";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectFieldProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  label: string;
  options: SelectOption[];
}

/** A labelled single-select — the dropdown form vocabulary (e.g. a status filter). Token-styled. */
export function SelectField({ label, options, ...rest }: SelectFieldProps) {
  return (
    <label className="fui-field">
      <span className="fui-field__label">{label}</span>
      <select className="fui-field__input fui-select" {...rest}>
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
